import {Component, OnInit} from '@angular/core';
import {EnumStorage} from "./Enums/enumStorage.enum";
import {ReferrerDetectorService} from "./services/other/referrer-detector.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  constructor(private referrerDetectorService:ReferrerDetectorService) {
  }


  ngOnInit(): void {
    //this.referrerDetectorService.redirectIfExternal();
  }
}
